
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import { Provider } from 'react-redux';
import store, { persistor } from './store';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import ReactGA from 'react-ga4';
// Initialize Google Analytics if key is present
if (process.env.REACT_APP_GOOGLE_ANALYTICS_KEY) {
  ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_KEY);
}

// Optionally initialize Google Analytics if needed
// if (process.env.REACT_APP_GOOGLE_ANALYTICS_KEY) {
//   ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_KEY);
// }


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // StrictMode removed to prevent double API calls in development
  // React.StrictMode intentionally double-renders components to help detect side effects,
  // but this causes duplicate API calls which is not acceptable for our use case
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);
